import axios from "axios";
import { Base_URL } from "../url";

export const saveEducationDetails = async (educationData, userName = "defaultUser") => {
  try {
    const response = await axios.post(
      `${Base_URL}/EducationMaster/CreateEducation?UserName=${userName}`,
      {
        resourceId: educationData.resourceId,
        educationCode: educationData.educationCode,
        educationType: educationData.educationType,
        instituteName: educationData.instituteName,
        yearOfPassing: educationData.yearOfPassing,
        grade: educationData.grade
      }
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving education details!";
  }
};

export const getAllResources = async () => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/ResourceMasters`);
    return response.data.map(resource => ({
      resourceId: resource.resourceId,
      name: resource.name
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching resources!";
  }
};